import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AceHighwayShipmentKeys from '../../../constants/locale/key/AceHighwayShipment'

const ACEHighwayShipmentTranslationText = () => {
    const { translate } = useTranslation([
        Namespace.ACE_HIGHWAY_SHIPMENT
    ])

    let headerId = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.HEADER_ID)
    let aceHighway = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.TITLE)
    let shipmentType = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SHIPMENT_TYPE)
    let entryType = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ENTRY_TYPE)
    let scn = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SCN)
    let acquittalNo = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ACQUITTAL_NO)
    let pointOfLoading = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.POINT_OF_LOADING)
    let fdaIndicator = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.FDA_INDICATOR)
    let splitIndicator = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SPLIT_INDICATOR)
    let serviceType = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SERVICE_TYPE)
    let inBond7512No = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.IN_BOND7512_NO)
    let masterInBondNo = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MASTER_IN_BOND_NO)
    let mexicanPedimento = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MEXICAN_PEDIMENTO)
    let foreignDestination = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.FOREIGN_DESTINATION)
    let inBondDestination = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.IN_BOND_DESTINATION)
    let firmsCode = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.FIRMS_CODE)
    let exitDate = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.EXIT_DATE)
    let quantity = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.QUANTITY)
    let consigneeName = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CONSIGNEE_NAME)
    let status = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.STATUS)
    let createdDate = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CREATED_DATE)
    let lastModifiedDate = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.LAST_MODIFIED_DATE)
    let submissionDate = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SUBMISSION_DATE)
    let responseDate = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.RESPONSE_DATE)
    let manifestId = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MANIFEST_ID)
    let shipperName = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SHIPPER_NAME)
    let brokerEntryNo = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.BROKER_ENTRY_NO)
    let customsBroker = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CUSTOMS_BROKER)
    let attachButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ATTACH_BUTTON)
    let draft = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DRAFT)
    let accepted = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ACCEPTED)
    let pending = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PENDING)
    let sent = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SENT)
    let preliminary = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PRELIMINARY)
    let statusNotification = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.STATUS_NOTIFICATION)
    let cancellationAccepted = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CANCELLATION_ACCEPTED)
    let cancellationRejected = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CANCELLATION_REJECTED)
    let modificationRejected = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MODIFICATION_REJECTED)
    let totalPackages = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.TOTAL_PACKAGES)
    let totalGrossWeight = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.TOTAL_GROSS_WEIGHT)
    let selectedShipmentPackages = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SELECTED_SHIPMENT_PACKAGES)
    let selectedShipmentGrossWeight = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SELECTED_SHIPMENT_GROSS_WEIGHT)
    let customsBrokerName = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CUSTOMS_BROKER_NAME)
    let customsBrokerContact = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CUSTOMS_BROKER_CONTACT)
    let additionalShipment = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ADDITIONAL_SHIPMENT)
    let attachShipmentSuccessMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ATTACH_SHIPMENT_SUCCESS_MSG)
    let monetaryAmountExceededLimit = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MONETARY_AMOUNT_EXCEEDED_LIMIT)
    let backButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.BACK_BUTTON)
    let proceedButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PROCEED_BUTTON)
    let submitButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SUBMIT_BUTTON)
    let uploadShipmentButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.UPLOAD_SHIPMENT_BUTTON)
    let detachButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DETACH_BUTTON)
    let detachMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DETACH_MSG)
    let detachSuccessMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DETACH_SUCCESS_MSG)
    let editButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.EDIT_BUTTON)
    let cloneButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CLONE_BUTTON)
    let cancelButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CANCEL_BUTTON)
    let attachShipmentSectionHelper = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ATTACH_SHIPMENT_SECTION_HELPER)
    let deleteButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DELETE_BUTTON)
    let cantDetachFromViewPage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CANT_DETACH_FROM_VIEW_PAGE)
    let cantSubmitFromViewPage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CANT_SUBMIT_FROM_VIEW_PAGE)
    let cantSubmitDiffShipType = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CANT_SUBMIT_DIFF_SHIP_TYPE)
    let messageFunction = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MESSAGE_FUNCTION)
    let msgFuncAdd = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MESSAGE_FUNCTION_ADD)
    let msgFuncModify = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MESSAGE_FUNCTION_MODIFY)
    let msgFuncCancel = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MESSAGE_FUNCTION_CANCEL)
    let failedToFetchAmendmentCodeOptions = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.FAILED_TO_FETCH_AMENDMENT_CODE_OPTIONS)
    let responseMessageAmendmentCode = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.RESPONSE_MESSAGE_AMENDMENT_CODE)
    let createNewShipment = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CREATE_NEW_SHIPMENT)
    let submitAllShipments = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SUBMIT_ALL_SHIPMENTS)
    let uploadNewShipment = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.UPLOAD_NEW_SHIPMENT)
    let attachShipment = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ATTACH_SHIPMENT)
    let propagate = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PROPAGATE)
    let setResponseMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SET_RESPONSE_MESSAGE)
    let onlyDraftStatusCanBeDeleted = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ONLY_DRAFT_STATUS_CAN_BE_DELETED)
    let shipmentCreated = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SHIPMENT_CREATED)
    let shipmentUpdated = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SHIPMENT_UPDATED)
    let propagateDataComfirmationMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PROPAGATE_DATA_COMFIRMATION_MSG)
    let propagateDataShipmentsNotSelectedComfirmationMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PROPAGATE_DATA_SHIPMENTS_NOT_SELECTED_COMFIRMATION_MSG)
    let propagateShipmentsUpdated = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PROPAGATE_SHIPMENTS_UPDATED)
    let deleteSucceeded = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DELETE_SUCCEEDED)
    let shipmentDeletionInProgress = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SHIPMENT_DELETION_IN_PROGRESS)
    let massDeleteSuccessMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MASS_DELETE_SUCCESS_MSG)
    let massDeleteFailedMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MASS_DELETE_FAILED_MSG)
    let shipmentCannotBeDetached = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SHIPMENT_CANNOT_BE_DETACHED)
    let addStatusNotificationOptional = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ADD_STATUS_NOTIFICATION_OPTIONAL)
    let deleteConfirmationMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DELETE_CONFIRMATION_MSG)
    let deleteConfirmButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DELETE_CONFIRM_BUTTON)
    let deleteCancelButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DELETE_CANCEL_BUTTON)
    let discardButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DISCARD_BUTTON) 
    let masterShipmentId = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MASTER_SHIPMENT_ID)
    let tripNo = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.TRIP_NO)
    let arrivalDate = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ARRIVAL_DATE)
    let amendmentCode = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.AMENDMENT_CODE) 
    let submitSentRecord = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SUBMIT_SENT_RECORD)
    let detachSentRecord = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DETACH_SENT_REC) 
    let cantEditST = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CANT_EDIT_ST_RECORD)
    let submitToCustoms = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SUBMIT_TO_CUSTOMS)
    let fillUpNewShipment = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.FILL_UP_NEW_SHIPMENT)
    let noFileAttachedMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.NO_FILE_ATTACHED_MSG)
    let uploadFailedMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.UPLOAD_FAILED_MSG)
    let uploadSuccessMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.UPLOAD_SUCCESS_MSG)
    let downloadTemplateCsv = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DOWNLOAD_TEMPLATE_CSV)
    let all = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ALL)
    let rejected = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.REJECTED)
    let cancelled = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CANCELLED)

    let goodsDetails = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.TITLE)
    let classificationWeightTitle = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.CLASSIFICATION_WEIGHT_TITLE)
    let goodsDescription = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.GOODS_DESCRIPTION)
    let noOfPackages = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.NO_OF_PACKAGES)
    let noOfPackagesUom = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.NO_OF_PACKAGES_UOM)
    let grossWeight = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.GROSS_WEIGHT)
    let grossWeightUom = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.GROSS_WEIGHT_UOM)
    let monetaryAmount = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.MONETARY_AMOUNT)
    let countryOfOrigin = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.COUNTRY_OF_ORIGIN)
    let harmonizedCodeTitle = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.HARMONIZED_CODE_TITLE)
    let harmonizedCode1 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.HARMONIZED_CODE1)
    let harmonizedCode2 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.HARMONIZED_CODE2)
    let harmonizedCode3 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.HARMONIZED_CODE3)
    let harmonizedCode4 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.HARMONIZED_CODE4)
    let harmonizedCode5 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.HARMONIZED_CODE5)
    let c4CodeTitle = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.C4_CODE_TITLE)
    let additionalInformation = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.ADDITIONAL_INFORMATION)
    let c4Code1 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.C4_CODE1)
    let c4Code2 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.C4_CODE2)
    let c4Code3 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.C4_CODE3)
    let c4Code4 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.C4_CODE4)
    let c4Code5 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.C4_CODE5)
    let marksNoTitle = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.MARKS_NO_TITLE)
    let marksNo1 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.MARKS_NO1)
    let marksNo2 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.MARKS_NO2)
    let marksNo3 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.MARKS_NO3)
    let marksNo4 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.MARKS_NO4)
    let marksNo5 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.MARKS_NO5)
    let vinTitle = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN_TITLE)
    let vin1 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN1)
    let vin2 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN2)
    let vin3 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN3)
    let vin4 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN4)
    let vin5 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN5)
    let vin6 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN6)
    let vin7 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN7)
    let vin8 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN8)
    let vin9 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN9)
    let vin10 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN10)
    let vin11 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN11)
    let vin12 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN12)
    let vin13 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN13)
    let vin14 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN14)
    let vin15 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN15)
    let vin16 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN16)
    let vin17 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN17)
    let vin18 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN18)
    let vin19 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN19)
    let vin20 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.VIN20)
    let searchEntries = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.SEARCH_ENTRIES)
    let addCommodity = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GoodsDetails.ADD_COMMODITY)

    let saveButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SAVE_BUTTON)
    let updateButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.UPDATE_BUTTON)
    let cloneMultipleRecords = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CLONE_MULTIPLE_RECORDS)
    let deleteMultipleRecords = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DELETE_MULTIPLE_RECORDS)
    let shipmentHeaderSectionHelper = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SHIPMENT_HEADER_SECTION_HELPER)
    let partySection = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PARTY_SECTION)
    let partySectionHelper = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PARTY_SECTION_HELPER)
    let goodsSectionHelper = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.GOODS_SECTION_HELPER)
    let shipmentInformation = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SHIPMENT_INFORMATION)
    let shipmentHeaderSectionAccount = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SHIPMENT_HEADER_SECTION_ACCOUNT)

    let bondedCarrierName = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.BONDED_CARRIER_NAME)
    let partyInfo = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.TITLE)
    let partyType = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PARTY_TYPE)
    let partyIdentifier = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PARTY_IDENTIFIER)
    let name1 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.NAME1)
    let name2 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.NAME2)
    let address1 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.ADDRESS1)
    let address2 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.ADDRESS2)
    let address3 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.ADDRESS3)
    let cityName = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.CITY_NAME)
    let postalCode = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.POSTAL_CODE)
    let country = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.COUNTRY)
    let state = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.STATE)
    let telNo = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.TEL_NO)
    let email = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.EMAIL)
    let ctpatInd = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.CTPAT_IND)
    let partyDropDown = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PARTY_DROP_DOWN)
    let partyIdentifierCode = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PARTY_IDENTIFIER_CODE)
    let partyIdentifierValue = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PARTY_IDENTIFIER_VALUE)
    let partyIdentifierValueNote = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PARTY_IDENTIFIER_VALUE_NOTE)
    let partyIdentifierValueEIN = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PARTY_IDENTIFIER_VALUE_EIN)
    let partyIdentifierValueSSN = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PARTY_IDENTIFIER_VALUE_SSN)
    let partyIdentifierValueCAN = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PARTY_IDENTIFIER_VALUE_CAN)
    let portCode = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PORT_CODE)
    let routingCode = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.ROUTING_CODE)
    let brokerDownloadRefNo = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.BROKER_DOWNLOAD_REF_NO)
    let portOfLoading = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PORT_OF_LOADING)
    let filerCode = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.FILER_CODE)
    let saveFlag = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.SAVE_FLAG)
    let phoneNo = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PHONE_NO)
    let faxNo = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.FAX_NO)
    let partyTemplate = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.PARTY_TEMPLATE)
    let otherDetails = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.OTHER_DETAILS)
    let ctpatMember = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.PartyInfo.CTPAT_MEMBER)

    let csvSelectFileType = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CSV_SELECT_FILE_TYPE)
    let csvFileSizeExceed = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CSV_FILE_SIZE_EXCEED)
    let csvInvalidFile = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CSV_INVALID_FILE)

    let dialogTitle = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.UPLOAD_XML_DILAOG_TITLE)
    let uploadXMLButton = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.UPLOAD_XML_BUTTON)
    let successMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.UPLOAD_XML_SUCCESS_MSG)
    let errorMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.UPLOAD_XML_ERROR_MSG)
    let fileEmptyMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.UPLOAD_XML_FILE_EMPTY_ERROR_MSG)
    
    let carrierScac = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CARRIER_SCAC)
    let dangerousGoods = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DangerousGoods.TITLE)
    let undgCode = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DangerousGoods.UNDG_CODE)
    let undgContactName = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DangerousGoods.UNDG_CONTACT_NAME)
    let undgContactNo = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.DangerousGoods.UNDG_CONTACT_NO)

    let submitSuccessMsg = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SUBMIT_SUCCESS_MESSAGE)
    let submitErrorMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SUBMIT_ERROR_MESSAGE)
    let submitCancelMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SUBMIT_CANCEL_MESSAGE)

    let editShipment = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.EDIT_SHIPMENT)
    let viewLogHistory = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.VIEW_LOG_HISTORY)
    let createShipment = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CREATE_SHIPMENT)
    let createOriginalSplitShipment = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CREATE_ORIGINAL_SPLIT_SHIPMENT)
    let createdSuccessfully = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CREATED_SUCCESSFULLY)
    let sendUnassociatedShipment = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SEND_UNASSOCIATED_SHIPMENT)
    let cancelShipmentMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.CANCEL_SHIPMENT_MESSAGE)
    let shipmentInfoUpdatedOnMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SHIPMENT_INFO_UPDATED_ON_MESSAGE)
    let accountType = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ACCOUNT_TYPE)
    let address = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ADDRESS)
    let fdaRegulated = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.FDA_REGULATED)
    let notFdaRegulated = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.NOT_FDA_REGULATED)
    let viewResponse = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.VIEW_RESPONSE)
    let onlyAcceptedStatusForCancellation = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ONLY_ACCEPTED_STATUS_FOR_CANCELLATION)
    let onlyMasterShipmentForCancellation = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ONLY_MASTER_SHIPMENT_FOR_CANCELLATION)
    let exportShipments = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.EXPORT_SHIPMENTS)
    let maximumOf500RecordsPerExport = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MAXIMUM_OF_500_RECORDS_PER_EXPORT)
    let exportShipmentInBackground = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.EXPORT_SHIPMENT_IN_BACKGROUND)
    let massDelete = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.MASS_DELETE)
    let responseLog = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.RESPONSE_LOG)
    let backToShipmentList = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.BACK_TO_SHIPMENT_LIST)

    let maxLengthErrorMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.Validations.MAX_LENGTH)
    let alphaNumericErrorMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.Validations.ALPHANUMERIC)
    let alphaNumericSpecialCharErrorMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.Validations.ALPHANUMERIC_SPECIAL_CHAR)
    let numericErrorMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.Validations.NUMERIC)
    let minLengthErrorMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.Validations.MIN_LENGTH)
    let emailValid = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.Validations.EMAIL_VALID)

    let regular = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.REGULAR)
    let brass = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.BRASS)
    let inBond = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.INBOND)
    let sec321 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.SEC321)
    let form3299 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.FORM3299)
    let form7523 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.FORM7523)
    let form3311 = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.FORM3311)
    let intangibles = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.INTANGIBLES)
    let astray = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ASTRAY)
    let iMail = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.IMAIL)

    let attachSentRecords = translate(Namespace.ACE_HIGHWAY_SHIPMENT, AceHighwayShipmentKeys.ATTACH_SENT_RECORDS)
    let submitSuccessMessage = translate(Namespace.ACE_HIGHWAY_SHIPMENT,AceHighwayShipmentKeys.SUBMIT_SUCCESS_MESSAGE)
    let msgFuncDelink = translate(Namespace.ACE_HIGHWAY_SHIPMENT,AceHighwayShipmentKeys.MESSAGE_FUNCTION_DELINK)

    return {
        headerId,
        aceHighway,
        shipmentType,
        entryType,
        scn,
        acquittalNo,
        pointOfLoading,
        fdaIndicator,
        splitIndicator,
        serviceType,
        inBond7512No,
        masterInBondNo,
        mexicanPedimento,
        foreignDestination,
        inBondDestination,
        firmsCode,
        exitDate,
        quantity,
        consigneeName,
        status,
        createdDate,
        lastModifiedDate,
        submissionDate,
        responseDate,
        manifestId,
        shipperName,
        brokerEntryNo,
        customsBroker,
        attachButton,
        draft,
        accepted,
        pending,
        sent,
        preliminary,
        statusNotification,
        cancellationAccepted,
        cancellationRejected,
        modificationRejected,
        totalPackages,
        totalGrossWeight,
        selectedShipmentPackages,
        selectedShipmentGrossWeight,
        customsBrokerName,
        customsBrokerContact,
        additionalShipment,
        attachShipmentSuccessMsg,
        monetaryAmountExceededLimit,
        backButton,
        proceedButton,
        submitButton,
        uploadShipmentButton,
        detachButton,
        detachMessage,
        detachSuccessMsg,
        editButton,
        cloneButton,
        cancelButton,
        attachShipmentSectionHelper,
        deleteButton,
        cantDetachFromViewPage,
        cantSubmitFromViewPage,
        cantSubmitDiffShipType,
        messageFunction,
        msgFuncAdd,
        msgFuncModify,
        msgFuncCancel,
        failedToFetchAmendmentCodeOptions,
        responseMessageAmendmentCode,
        createNewShipment,
        submitAllShipments,
        uploadNewShipment,
        attachShipment,
        propagate,
        setResponseMessage,
        onlyDraftStatusCanBeDeleted,
        shipmentCreated,
        shipmentUpdated,
        propagateDataComfirmationMsg,
        propagateDataShipmentsNotSelectedComfirmationMsg,
        propagateShipmentsUpdated,
        deleteSucceeded,
        shipmentDeletionInProgress,
        massDeleteSuccessMsg,
        massDeleteFailedMsg,
        shipmentCannotBeDetached,
        addStatusNotificationOptional,
        deleteConfirmationMsg,
        deleteConfirmButton,
        deleteCancelButton,
        discardButton,
        masterShipmentId,
        tripNo,
        arrivalDate,
        amendmentCode,
        submitSentRecord,
        detachSentRecord,
        cantEditST,
        submitToCustoms,
        fillUpNewShipment,
        noFileAttachedMsg,
        uploadFailedMsg,
        uploadSuccessMsg,
        downloadTemplateCsv,
        all,
        rejected,
        cancelled,
        goodsDetails,
        classificationWeightTitle,
        goodsDescription,
        noOfPackages,
        noOfPackagesUom,
        grossWeight,
        grossWeightUom,
        monetaryAmount,
        countryOfOrigin,
        harmonizedCodeTitle,
        harmonizedCode1,
        harmonizedCode2,
        harmonizedCode3,
        harmonizedCode4,
        harmonizedCode5,
        c4CodeTitle,
        additionalInformation,
        c4Code1,
        c4Code2,
        c4Code3,
        c4Code4,
        c4Code5,
        marksNoTitle,
        marksNo1,
        marksNo2,
        marksNo3,
        marksNo4,
        marksNo5,
        vinTitle,
        vin1,
        vin2,
        vin3,
        vin4,
        vin5,
        vin6,
        vin7,
        vin8,
        vin9,
        vin10,
        vin11,
        vin12,
        vin13,
        vin14,
        vin15,
        vin16,
        vin17,
        vin18,
        vin19,
        vin20,
        searchEntries,
        addCommodity,
        saveButton,
        updateButton,
        cloneMultipleRecords,
        deleteMultipleRecords,
        shipmentHeaderSectionHelper,
        partySection,
        partySectionHelper,
        goodsSectionHelper,
        shipmentInformation,
        shipmentHeaderSectionAccount,
        bondedCarrierName,
        partyInfo,
        partyType,
        partyIdentifier,
        name1,
        name2,
        address1,
        address2,
        address3,
        cityName,
        postalCode,
        country,
        state,
        telNo,
        email,
        ctpatInd,
        partyDropDown,
        partyIdentifierCode,
        partyIdentifierValue,
        partyIdentifierValueNote,
        partyIdentifierValueEIN,
        partyIdentifierValueSSN,
        partyIdentifierValueCAN,
        portCode,
        routingCode,
        brokerDownloadRefNo,
        portOfLoading,
        filerCode,
        saveFlag,
        phoneNo,
        faxNo,
        partyTemplate,
        otherDetails,
        ctpatMember,
        csvSelectFileType,
        csvFileSizeExceed,
        csvInvalidFile,
        dialogTitle,
        uploadXMLButton,
        successMsg,
        errorMsg,
        fileEmptyMsg,
        carrierScac,
        dangerousGoods,
        undgCode,
        undgContactName,
        undgContactNo,
        submitSuccessMsg,
        submitErrorMessage,
        submitCancelMessage,
        editShipment,
        viewLogHistory,
        createShipment,
        createOriginalSplitShipment,
        createdSuccessfully,
        sendUnassociatedShipment,
        cancelShipmentMessage,
        shipmentInfoUpdatedOnMessage,
        accountType,
        address,
        fdaRegulated,
        notFdaRegulated,
        viewResponse,
        onlyAcceptedStatusForCancellation,
        onlyMasterShipmentForCancellation,
        exportShipments,
        maximumOf500RecordsPerExport,
        exportShipmentInBackground,
        massDelete,
        responseLog,
        backToShipmentList,
        maxLengthErrorMessage,
        alphaNumericErrorMessage,
        alphaNumericSpecialCharErrorMessage,
        numericErrorMessage,
        minLengthErrorMessage,
        emailValid,
        regular,
        brass,
        inBond,
        sec321,
        form3299,
        form7523,
        form3311,
        intangibles,
        astray,
        iMail,
        attachSentRecords,
        submitSuccessMessage,
        msgFuncDelink
    }
}

export default ACEHighwayShipmentTranslationText